import { Injectable } from '@angular/core';
import { Router, PRIMARY_OUTLET } from '@angular/router';

const PAYLOC_LIST_PATH = 'payloc/list';
const ACCESS_DENIED_PATH = '/access-denied';
const SIGNED_OUT_PATH = '/signed-out';

@Injectable({
  providedIn: 'root'
})
export class AppNavigationService {

  constructor(
    private router: Router
  ) { }

  public goToPaylocList(): Promise<boolean> {
    return this.router.navigate([PAYLOC_LIST_PATH]);
  }

  public goToPayLoc(payNum: number): Promise<boolean> {
    return this.router.navigate(['payloc/' + payNum + '/edit']);
  }

  public goToAccessDenied(): Promise<boolean> {
    return this.router.navigate([ACCESS_DENIED_PATH]);
  }

  public goToSignedOut(): Promise<boolean> {
    return this.router.navigate([SIGNED_OUT_PATH]);
  }
}
